import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/muthueshop.com/httpdocs/src/app/collections/[slug]/CollectionsClient.tsx");
